<div
  class="generic-picker"
  [ngStyle]="{ 'min-width': 'fit-content', width: width }"
>
  <!-- Search Input -->
  <ng-container *ngIf="!selectedItem; else selectedItemTemplate">
    <div class="search-container">
      <dds-search
        [formControl]="searchFormCtrl"
        [size]="searchOptions.size"
        [disabled]="isPickerDisabled"
        (valueChanged)="onSearchInput()"
        (fieldCleared)="onClearSearch()"
      >
        <input
          ddsSearch
          class="dropdown-toggle"
          [placeholder]="placeholder"
          [(ngModel)]="searchStr"
          [disabled]="isPickerDisabled"
          [ngClass]="{ hidden: selectedItem }"
          [maxlength]="maxLength"
          aria-haspopup="true"
          aria-haspopup="false"
          (input)="onSearchInput()"
          (click)="onSearchInputClick()"
          (blur)="onSearchInputBlur($event)"
        />
        <!-- Loader -->
        <div *ngIf="isSpinnerVisible && isLoading" class="loader">
          <dds-spinner
            [size]="spinnerOptions.size ?? EMPTY"
            [theme]="spinnerOptions.theme ?? EMPTY"
            [isInverse]="spinnerOptions.isInverse ?? false"
            [thickness]="spinnerOptions.thickness ?? EMPTY"
          ></dds-spinner>
        </div>
      </dds-search>
    </div>
  </ng-container>
  <!-- Dropdown Container -->
  <div
    *ngIf="showDropdown && !selectedItem"
    class="dropdown-container dropdown-menu rounded-0"
    [class.show]="showDropdown"
    [ngStyle]="{ 'max-height': stickerMaxHeight }"
    (scroll)="onScroll($event)"
  >
    <!-- Searching Message -->
    <div
      *ngIf="isLoading && items.length === 0"
      class="dropdown-item searching-text"
    >
      {{ searchingText }}
    </div>

    <!-- No Matches Found -->
    <div
      *ngIf="
        !isLoading && items.length === 0 && searchStr.length >= minSearchLength
      "
      class="dropdown-item no-matches"
    >
      {{ noMatchesText }}
    </div>

    <!-- Default Template -->
    <ng-container
      *ngIf="
        items.length > 0 && !dropdownContentCustomTemplate;
        else customDropdownTemplate
      "
    >
      <button
        *ngFor="let item of items"
        class="dropdown-item"
        [disabled]="isLoading"
        (click)="onSelectItem(item)"
      >
        {{ item }}
      </button>
    </ng-container>

    <!-- Custom Template -->
    <ng-template #customDropdownTemplate>
      <ng-container
        *ngTemplateOutlet="
          dropdownContentCustomTemplate;
          context: { $implicit: items }
        "
      ></ng-container>
    </ng-template>
  </div>
</div>

<!-- Selected Item View -->
<ng-template #selectedItemTemplate>
  <div
    class="selected-item-view"
    [ngClass]="{ 'with-border': showSelectedItemBorder }"
  >
    <span
      class="selected-item-text"
      [ngClass]="{ 'flex-1': showSelectedItemBorder }"
      >{{ selectedItem }}</span
    >

    <div class="icon-containers">
      <button
        *ngIf="showCopyIcon"
        class="dds-btn dds-btn_dark dds-btn_silent dds-icon dds-icon_copy__l__stroke icon"
        aria-label="Copy"
        title="Copy"
        (click)="copySelectedItem()"
      ></button>

      <button
        *ngIf="showClearIcon"
        class="dds-btn dds-btn_dark dds-btn_silent dds-icon dds-icon_close"
        aria-label="Clear"
        title="Clear"
        (click)="clearSelectedItem()"
      ></button>

      <button
        *ngIf="showEditIcon"
        class="dds-btn dds-btn_dark dds-btn_silent dds-icon dds-icon_edit__s__filled"
        aria-label="Edit"
        title="Edit"
        (click)="editSelectedItem()"
      ></button>
    </div>
  </div>
</ng-template>
